import React from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react';
import ReactSelect from 'react-select';
import { useTarefaModal, TAREFA_STATUS, TAREFA_PERIODICIDADE } from './hooks/useTarefaModal';

export { TAREFA_STATUS, TAREFA_PERIODICIDADE };

const DIAS_SEMANA = [
  { value: 0, label: 'Dom' },
  { value: 1, label: 'Seg' },
  { value: 2, label: 'Ter' },
  { value: 3, label: 'Qua' },
  { value: 4, label: 'Qui' },
  { value: 5, label: 'Sex' },
  { value: 6, label: 'Sab' },
];

export default function TarefaModal({ isOpen, onClose, clinicaId, onCreated }) {
  const {
    setSelected,
    titulo,
    setTitulo,
    descricao,
    setDescricao,
    dataFinal,
    setDataFinal,
    horario,
    setHorario,
    periodicidade,
    diasSemana,
    saving,
    canSave,
    userOptions,
    selectedOption,
    handleClose,
    handleSave,
    handlePeriodicidadeChange,
    handleDiaSemanaChange,
  } = useTarefaModal({ isOpen, onClose, clinicaId, onCreated });

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg" isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Nova tarefa</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={3} align="stretch">
            <FormControl isRequired>
              <FormLabel>Usuários</FormLabel>
              <ReactSelect
                options={userOptions}
                value={selectedOption}
                onChange={(opt) => setSelected(opt ? { value: opt.value, label: opt.label, role: opt.role } : null)}
                placeholder="Pesquisar usuário..."
                isClearable
                isDisabled={!clinicaId}
                noOptionsMessage={() => 'Nenhum usuário encontrado'}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Nome da tarefa</FormLabel>
              <Input
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                placeholder="Nome da tarefa"
                maxLength={120}
              />
              <Text fontSize="xs" color="gray.500" mt={1}>
                {titulo.trim().length}/120
              </Text>
            </FormControl>

            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Textarea
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                placeholder="Descrição"
                minH="90px"
                maxLength={2000}
              />
            </FormControl>

            <HStack spacing={3} wrap="wrap">
              <FormControl>
                <FormLabel>Data final</FormLabel>
                <Input type="date" value={dataFinal} onChange={(e) => setDataFinal(e.target.value)} />
              </FormControl>
              <FormControl>
                <FormLabel>Horário</FormLabel>
                <Input type="time" value={horario} onChange={(e) => setHorario(e.target.value)} />
              </FormControl>
            </HStack>

            <HStack spacing={3} wrap="wrap">
              <FormControl>
                <FormLabel>Periodicidade</FormLabel>
                <Select value={periodicidade} onChange={(e) => handlePeriodicidadeChange(e.target.value)}>
                  <option value={TAREFA_PERIODICIDADE.NENHUMA}>Sem periodicidade</option>
                  <option value={TAREFA_PERIODICIDADE.DIARIA}>Diária</option>
                  <option value={TAREFA_PERIODICIDADE.SEMANAL}>Semanal</option>
                  <option value={TAREFA_PERIODICIDADE.MENSAL}>Mensal</option>
                </Select>
              </FormControl>
            </HStack>

            {periodicidade === TAREFA_PERIODICIDADE.SEMANAL && (
              <FormControl>
                <FormLabel>Dias da semana</FormLabel>
                <HStack spacing={3} wrap="wrap">
                  {DIAS_SEMANA.map((d) => (
                    <Checkbox
                      key={d.value}
                      isChecked={diasSemana.includes(d.value)}
                      onChange={(e) => handleDiaSemanaChange(d.value, e.target.checked)}
                    >
                      {d.label}
                    </Checkbox>
                  ))}
                </HStack>
              </FormControl>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={handleClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" ml={3} onClick={handleSave} isLoading={saving} isDisabled={!canSave}>
            Criar tarefa
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
